<template>
  <div class="container">
    <section class="section">
      <div class="box">
        <h2 class="title">
          Evidence of Insurance Status
        </h2>
        <div class="columns">
          <div class="column is-half">
            <p>Your Evidence of Insurance is ready for download. Provide this form as Evidence of Homeowners Insurance to your bank as needed for your mortage banking needs.</p>
          </div>
          <div class="column is-half has-text-centered">
            <a href="/static/ACCORD-EOI.pdf">
              <i class="fa fa-file-pdf-o fa-4x" aria-hidden="true"></i>
              <p>ACOORD-EOI.pdf</p>
            </a>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'Status'
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1,
h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}
</style>


// WEBPACK FOOTER //
// src/components/request/Status.vue?ee8b46f8